import axiosHandler from "./axios-handler";

export default async function getAllUserLessons(courseUid = "") {

  let baseURL = `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/courses/${courseUid}/lessons`;
  const options = {
    method: "GET",
    url: baseURL,
    withCredentials: true,
  };
  const response = await axiosHandler(options);
  return response;
}
